export class AppConstants {
    public static IMAGE_PATH_PAYMENT_OPTIONS = './assets/images/payment-options/';
    public static IMAGE_PATH_OTHERS = './assets/images/';
    public static IMAGE_EXTENSION = '.svg';
    public static CORAL_FEID = 'cl';
    public static DEPOSIT_INPUT = '1';
    public static DEPOSIT_SUCCESS = '2';
    public static DEPOSIT_FAILURE = '3';
    public static V2 = 'v2';
    public static V3 = 'v3';
    public static FLASH1VOUCHER = 'FLASH1VOUCHER';
    public static AMEX = 'AMEX';
    public static CCFAMILY = ['VISA', 'MASTERCARD', 'GAMERSCARD', 'ENTROPAY', 'DINERS', 'MLIFE', 'DANKORT', 'VISA-QUWI', 'AMEX', 'DISCOVER'];
    public static PREPAIDCARDS = ['BORGATAPREPAIDCARD', 'PLAYMGMPREPAIDCARD', 'PARTYPREPAIDCARD', 'MLIFE'];
    public static PREPAIDCARDSAndECHECKS = ['BORGATAPREPAIDCARD', 'PLAYMGMPREPAIDCARD', 'PARTYPREPAIDCARD', 'MLIFE', 'INSTANTECHECKS'];
}

export class ProductType {
    public static POKER = 'POKER';
    public static SPORTS = 'SPORTS';
    public static SPORTSBOOK = 'SPORTSBOOK';
    public static CASINO = 'CASINO';
    public static BETTING = 'BETTING';
    public static BINGO = 'BINGO';
}
export const LIMIT_PERIOD = ['daily', 'weekly', 'monthly'];

export class BrandType {
    public static CORAL = 'CORAL';
    public static LADBROKEUK = 'LADBROKEUK';
    public static LADBROKEDE = 'LADBROKEDE';
}

export class ProposedProduct {
    public static SLOTSANDPOKER = 'Slots and Poker';
    public static SLOTS = 'Slots';
    public static POKER = 'Poker';
    public static SPORTS = 'Sports';
}

export class PageName {
    public static KYCLimitsExceeded = 'KYCLimitsExceeded';
    public static GamingLimitsNotConfigured = 'gamingLimitsNotConfigured';
    public static ProrgDepLimitExceeded = 'prorgDepLimitExceeded';
    public static AMLNetDepositLimitsExceeded = 'AMLNetDepositLimitsExceeded';
    public static AffordibilityNetDepositLimitsExceeded = 'AffordibilityNetDepositLimitsExceeded';
    public static SvocAffordibilityNetDepositLimitsExceeded = 'SvocAffordibilityNetDepositLimitsExceeded';
    public static PurchaseLimitsExceeded = 'PurchaseLimitsExceeded';
    public static CentralDepLimitsExceeded = 'CentralDepLimitsExceeded';
    public static DepositLimitsExceeded = 'DepositLimitsExceeded';
    public static InstrumentLimitExceeded = 'InstrumentLimitExceeded';
    public static GamerscardErrorCodes = 'GamerscardErrorCodes';
    public static CreditCardBlockDetails = 'CreditCardBlockDetails';
    public static ArcDepositDecline = 'ArcDepositDecline';
    public static DoNotHonorMessage = 'DoNotHonorMessage';
    public static InsufficientFunds = 'InsufficientFunds';
    public static Flash1VoucherError = 'Flash1VoucherError';
    public static DepositDecline = 'DepositDecline';
    public static invalidCvv = 'invalidCvv';
    public static internalError = 'internalError';
    public static RiskPlayerMessage = 'RiskPlayerMessage';
    public static IntensivePlayerMessage = 'IntensivePlayerMessage';
}
export class InputType {
    public static PAYPAL = 'PAYPAL';
    public static CANADIANEFT = 'CANADIANEFT';
    public static SKRILL1TAP = 'SKRILL1TAP';
    public static VENMO = 'VENMO';
    public static INSTANTECHECKS = 'INSTANTECHECKS';
    public static FLASH1VOUCHER = 'FLASH1VOUCHER';
    public static PREPAIDCARD = 'PREPAIDCARD';
    public static PAYPALDIRECT = 'PAYPALDIRECT';
    public static VISA = 'VISA';
    public static PLAYMGMPREPAIDCARD = 'PLAYMGMPREPAIDCARD';
    public static BORGATAPREPAIDCARD = 'BORGATAPREPAIDCARD';
    public static PARTYPREPAIDCARD = 'PARTYPREPAIDCARD';
    public static NONPAYPAL = 'NONPAYPAL';
    public static APPLEPAY = 'APPLEPAY';
    public static APPLEPAYDIRECT = 'APPLEPAYDIRECT';
    public static MLIFE = 'MLIFE';
    public static GAMERSCARD = 'GAMERSCARD';
    public static allDepositOptions = 'allDepositOptions';
}

export class Config {
    public static YES = 'Y';
}

export class Jurisdiction {
    public static DEU = 'DEU';
}

export class Country {
    public static US = 'US';
    public static UK = 'GB';
    public static NL = 'NL';
}

export class ChannelType {
    public static WC = 'WC';
    public static VC = 'VC';
    public static FC = 'FC';
    public static MC = 'MC';
    public static AN = 'AN';
    public static IN = 'IN';
    public static AW = 'AW';
    public static IW = 'IW';
    public static IH = 'IH';
}

export class CurrencyCode {
    public static ZAR = 'ZAR';
}

export class LiveChatResponse {
    public static LiveChatResponse_1001 = '1001';
    public static LiveChatResponse_1000 = '1000';
}

export class QDType {
    public static LCGBETSLIP = 'LCGBETSLIP';
    public static GVCBETSLIP = 'GVCBETSLIP';
}
export class LCGAmountInfo {
    public static amountGridIncrementalValue = 5.0;
    public static amountGridDecrementalValue = 5.0;
    public static gridAmounts = [20, 50, 100, 200];
}

export class GVCAmountInfo {
    public static amountGridIncrementalValue = 5.0;
    public static gridAmounts = [5, 10, 20, 50, 100];
}

export class WithdrawalInputType {
    public static PAY_PAYPAL = 'pay_paypal';
    public static PAY_VISA = 'pay_visa';
}
export const CURRENCY_NARROW_DISPLAY_LIST = ['zar', 'cop', 'cad'];
export const GEOCOMPLY_INIT_SOURCE = 'BQD-Deposit';
export const MOBILE_APP_CHANNELS = ['AH', 'AW', 'AN', 'IH', 'IW', 'IN'];

export const GENERIC_ERROR_MESSAGES = {
    TRY_ANOTHER_METHOD: 'PARTY.CASHIER.web.deposit.ach_interchecks.try_another_method',
    INSUFFICIENT_FUNDS: 'PARTY.CASHIER.web.deposit.ach_interchecks.insufficient_funds',
    DEPOSITS_NOT_ACCEPTED: 'PARTY.CASHIER.web.deposit.ach_interchecks.deposit_not_accepted',
    TROUBLE_TO_CONNECT: 'PARTY.CASHIER.web.deposit.ach_interchecks.trouble_to_connect',
    ACCOUNT_ALREADY_CONNECTED: 'PARTY.CASHIER.web.deposit.ach_interchecks.account_already_connected',
    ACCOUNT_BLOCKED: 'PARTY.CASHIER.web.deposit.ach_interchecks.account_blocked',
};

export const INTERCHECKS_ACH_ERROR_CODES: any = {
    ERR_ACCOUNT_BALANCE_THRESHOLD: GENERIC_ERROR_MESSAGES.INSUFFICIENT_FUNDS,
    ERR_ACCOUNT_BALANCE_UNAVAILABLE: GENERIC_ERROR_MESSAGES.TRY_ANOTHER_METHOD,
    ERR_INSUFFICIENT_FUNDS: GENERIC_ERROR_MESSAGES.INSUFFICIENT_FUNDS,
    ERR_ACCOUNT_RISK_BANK_BALANCE_THRESHOLD: GENERIC_ERROR_MESSAGES.DEPOSITS_NOT_ACCEPTED,
    ERR_ACCOUNT_RISK_THRESHOLD: GENERIC_ERROR_MESSAGES.DEPOSITS_NOT_ACCEPTED,
    ERR_ACCOUNT_RISK_METRICS_UNAVAILABLE: GENERIC_ERROR_MESSAGES.TROUBLE_TO_CONNECT,
    ERR_ACCOUNT_RISK_LEVEL_NOT_CONFIGURED: GENERIC_ERROR_MESSAGES.TRY_ANOTHER_METHOD,
    ERR_ACCOUNT_SHARING_LIMIT_EXCEEDED: GENERIC_ERROR_MESSAGES.ACCOUNT_ALREADY_CONNECTED,
    ERR_BANK_ACCOUNT_USER_BLOCKED: GENERIC_ERROR_MESSAGES.ACCOUNT_BLOCKED,
    ERR_BANK_ACCOUNT_BLOCKED: GENERIC_ERROR_MESSAGES.ACCOUNT_BLOCKED,
    ERR_ACCOUNT_NAME_MISMATCH: 'PARTY.CASHIER.web.deposit.ach_interchecks.account_name_mismatch',
    ERR_ACCOUNT_TYPE_RESTRICTED: 'PARTY.CASHIER.web.deposit.ach_interchecks.account_type_restricted',
    ERR_USER_EXITED_PLAID: 'PARTY.CASHIER.web.deposit.ach_interchecks.user_exited_plaid',
    ERR_INVALID_ACCOUNT_ID: 'PARTY.CASHIER.web.deposit.ach_interchecks.invalid_accountid',
    DEFAULT: GENERIC_ERROR_MESSAGES.TRY_ANOTHER_METHOD,
};
